<template>
  <div id="table">
    <table class="table">
      <tr>
        <td colspan="5" class="text-center">
          <span class="flag-icon" style="font-size: 120px;border:1px solid #eee;" :class="flagClass"></span>
          <div class="mt-2"><h2>{{ typeTitle }}</h2></div>
        </td>
      </tr>
      <tr>
        <td class="text-center">Date</td>
        <td colspan="4">
          <flat-pickr :config="{time_24hr: true, dateFormat: 'Y-m-d'}" v-model="lotto.lotto_date" placeholder="Date" />
        </td>
      </tr>
      <tr>
        <td class="text-center">Start Spin</td>
        <td colspan="4">
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.start_spin" placeholder="Start" />
          <div v-if="invalidStartSpin" class="text-danger text-sm">Please set start time</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">Start Show</td>
        <td colspan="4">
          <flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S', minDate: lotto.start_spin}" v-model="lotto.show_2nd" placeholder="Start Show" />
        </td>
      </tr>
      <tr>
        <td class="text-center">1ST</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_1st" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_1st">
          <div class="text-danger text-sm">{{ errors.first('prize_1st') }}</div>
        </td>
        <td></td>
        <td rowspan="2" class="text-center">Show Result</td>
        <td rowspan="2">
          <flat-pickr v-if="lotto.show_2nd" :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S', minDate: lotto.start_spin}" v-model="lotto.show_1st" placeholder="Show 1ST" />
          <em v-else><small>Please set show 2ND</small></em>
        </td>
      </tr>
      <tr>
        <td class="text-center">2ND</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_2nd" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_2nd">
          <div class="text-danger text-sm">{{ errors.first('prize_2nd') }}</div>
        </td>
        <td></td>
      </tr>
      <tr>
        <td rowspan="2" class="text-center">3RD</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_1" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_1">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_1') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_2" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_2">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_2') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_3" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_3">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_3') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_4" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_4">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_4') }}</div>
        </td>
      </tr>
      <tr>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_5" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_5">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_5') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_6" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_6">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_6') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_7" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_7">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_7') }}</div>
        </td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_3rd_8" v-validate="'numeric|length:5'" data-vv-as="*" data-vv-validate-on="blur" placeholder="number 5 digits" maxlength="5" v-model="lotto.results.prize_3rd_8">
          <div class="text-danger text-sm">{{ errors.first('prize_3rd_8') }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="6">
          <vs-button class="vs-xs-12 float-right" color="success" @click="save">Save</vs-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "moment"

//import Datepicker from 'vuejs-datepicker';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'ResultForm',
  components: {
    //Datepicker,
    flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lotto: this.data,
      invalidStartSpin: false
    }
  },
  watch: {
    data() {
      this.lotto = this.data
    }
  },
  computed: {
    minShow1st() {
      if (this.lotto.show_2nd)
        return moment(this.lotto.show_2nd).add(5, 'minute').format("YYYY-MM-DD HH:mm:ss")
      else
        return ''
    },
    lottoType() {
      return this.lotto.lotto_type
    },
    flagClass() {
      let fClass = '';
      switch(this.lottoType) {
        case 'gb':
          fClass = 'flag-icon-gb'
          break
        case 'de':
          fClass = 'flag-icon-de'
          break
        case 'ru':
          fClass = 'flag-icon-ru'
          break
      }
      return fClass
    },
    typeTitle() {
      let tTitle = '';
      switch(this.lottoType) {
        case 'gb':
          tTitle = 'ENGLAND VIP'
          break
        case 'de':
          tTitle = 'GERMANY VIP'
          break
        case 'ru':
          tTitle = 'RUSSIA VIP'
          break
      }
      return tTitle
    }
  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        this.invalidStartSpin = this.lotto.start_spin === ''
        if (valid && !this.invalidStartSpin) {
          this.$emit('save', this.lotto)
        }
      })
    }
  }
}

</script>
<style lang="scss">
#table {
  .table {
    width: auto;
    background-color: #FFF;
    border-collapse: collapse;
  }

  .table {
    tr {
      td {
        &:first-child {
          width: 200px;
          font-weight: bold;
        }

        .vs-input--input {
          width: auto;
        }

        input {
          border: 1px solid rgba(0, 0, 0, 0.2);
          color: blue;
        }

        .vdp-datepicker input {
          width: auto;
        }
      }

      td {
        padding: 16px 8px;
        border: 1px solid #DDDDDD;
        border-collapse: collapse;
      }

      .no-boder-r {
        border-right: 0;
      }

      .no-boder-l {
        border-left: 0;
      }

      .no-boder-t {
        border-top: 0;
      }

      .no-boder-b {
        border-bottom: 0;
      }
    }
  }

  .text-center {
    text-align: center;
  }
}

</style>
